var _defs, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _path10, _path11, _path12, _path13, _path14, _rect4, _rect5, _path15, _rect6, _path16, _path17, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 609.98 593.41",
    id: "online-worlds",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 285.52,
    x2: 306.45,
    y1: 967.73,
    y2: 237.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 306.75,
    x2: 320.06,
    y1: 362.33,
    y2: 534.16,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 409.19,
    x2: 404.89,
    y1: 813.55,
    y2: -75.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 536.38,
    x2: 524.88,
    y1: 207.8,
    y2: 380.23,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 264.05,
    x2: 272.95,
    y1: 93.81,
    y2: 254.79,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 514.8,
    x2: 566.92,
    y1: 224.51,
    y2: 224.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 309.42,
    x2: 310.32,
    y1: 27.65,
    y2: 68.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 331.57,
    x2: 344.78,
    y1: 122.71,
    y2: 131.21,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 330.53,
    x2: 252.53,
    y1: 175.18,
    y2: 204.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5db4cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#50819b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#475c76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#41455e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 376.46,
    x2: 422.39,
    y1: 128.57,
    y2: 128.57,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 299.26,
    x2: 310.53,
    y1: 181.26,
    y2: 181.26,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 414.53,
    x2: 450.84,
    y1: 218.06,
    y2: 218.06,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 156.54,
    x2: 667.49,
    y1: 567.15,
    y2: 567.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 343.29,
    x2: 348.07,
    y1: 97.04,
    y2: 125.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f0dcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 467.92,
    x2: 495.89,
    y1: 240.41,
    y2: 240.41,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 201.95,
    x2: 198.77,
    y1: 152,
    y2: 153.2,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 366.5,
    x2: 354.85,
    y1: 152.38,
    y2: 200.07,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 485.48,
    x2: 629.9,
    y1: 286.33,
    y2: 365.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 487.77,
    x2: 388.73,
    y1: 254.19,
    y2: 283.14,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M137.97 74.18c-32.26 12.92-66.76 21.79-95.19 41.78s-49.93 55.45-40.56 88.92c7.27 25.92 31.51 46.19 32.61 73.09.88 21.47-13.32 40.22-20.86 60.34-15.23 40.65-2.06 88 24.89 122s65.8 56.62 105.6 73.94a590.18 590.18 0 0 0 299.88 45.16c30.46-3.42 61.19-9.42 88.19-23.92s50.09-38.53 57.64-68.23c10.27-40.35-8.94-83.9 1.56-124.19 4.11-15.8 12.63-30.23 16.26-46.15 8.73-38.37-12.54-77.56-39.6-106.12s-60.46-50.92-85.2-81.52c-17.14-21.19-29.7-45.84-47.32-66.63C401.25 21.77 345.34-2.37 291.7.19c-53.29 2.53-103.46 53.86-153.73 73.99Z",
    opacity: 0.18
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 373.77,
    height: 501.74,
    x: 118.11,
    y: 37.54,
    fill: "#68e1fd",
    rx: 35.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 373.77,
    height: 501.74,
    x: 118.11,
    y: 37.54,
    fill: "url(#a)",
    rx: 35.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m409.2 382.64-194.78-1.23a27.86 27.86 0 0 0-28 27.69l-.18 28.7a27.87 27.87 0 0 0 27.69 28.05L398.6 467a47.28 47.28 0 0 1 32.65 13.39l5.17 5 .29-46 .07-11 .11-17.72a27.86 27.86 0 0 0-27.69-28.03Z",
    transform: "translate(-100.66 -3.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M466.96 95.24V492.1a31.09 31.09 0 0 1-31.08 31.08h-259.7a31.07 31.07 0 0 1-31.07-31.08V95.24a31.07 31.07 0 0 1 31.07-31.08h259.7a31.09 31.09 0 0 1 31.08 31.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M567.62 98.83v396.86a31.09 31.09 0 0 1-31.08 31.08h-259.7a31.07 31.07 0 0 1-31.07-31.08V98.83a31.07 31.07 0 0 1 31.07-31.08h259.7a31.09 31.09 0 0 1 31.08 31.08Z",
    opacity: 0.69,
    transform: "translate(-100.66 -3.59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M640.5 277v25.36A24.5 24.5 0 0 1 616.12 327h-161.6a40.69 40.69 0 0 0-9.1 1 41.24 41.24 0 0 0-19.54 10.61l-4.54 4.39v-66a24.59 24.59 0 0 1 17-23.46 24.19 24.19 0 0 1 7.41-1.16h170.4A24.5 24.5 0 0 1 640.5 277Z",
    transform: "translate(-100.66 -3.59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m376.46 157.14 4.15 64.28h-4.15l-4.46-4.29c-7.58-7.27-19.12-9.87-29.61-9.87H183.51a24 24 0 0 1-24-24l1.49-26.12a24 24 0 0 1 24-24h167.5a23.92 23.92 0 0 1 19.81 10.49 23.82 23.82 0 0 1 4.15 13.51Z",
    transform: "translate(-100.66 -3.59)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M380.61 157.14v64.28l-4.47-4.29A40.65 40.65 0 0 0 348 205.8H189.11a24 24 0 0 1-24-24v-24.66a24 24 0 0 1 24-24h167.53a23.94 23.94 0 0 1 19.82 10.49 23.82 23.82 0 0 1 4.15 13.51ZM640.5 274.94v24.69a24 24 0 0 1-24 24H457.65a40.67 40.67 0 0 0-28.15 11.33l-4.5 4.26v-64.28a23.95 23.95 0 0 1 24-24h167.53a24 24 0 0 1 23.97 24Z",
    transform: "translate(-100.66 -3.59)",
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M364.1 242.47c-1-2-2.6-3.52-3.58-5.46-2.1-4.14-.87-9.28 1.61-13.2 1-1.63 2.3-3.2 2.67-5.09.43-2.22-.43-4.64.5-6.7.76-1.66 2.48-2.62 4-3.68 2.31-1.65 4.31-3.81 6.92-4.91s6.23-.7 7.51 1.84c2.41-1.19 5.46-.11 7.26 1.87s2.6 4.68 3.15 7.3a61.88 61.88 0 0 0 2.06 8.88c1.06 2.85 2.92 5.56 5.67 6.85 5.34 2.5 12.78-.74 17 3.42 2.16 2.15 2.93 5.95 5.86 6.77 1.51.42 3.15-.13 4.65.27 2.59.7 3.66 3.83 3.72 6.51a19.1 19.1 0 0 1-5.87 14.1c-1.86 1.77-4.24 3.42-4.62 6a17.74 17.74 0 0 0 .3 3.9 9 9 0 0 1-14.37 7.94c-2.12-1.58-3.91-4.23-6.55-4.11a7.12 7.12 0 0 0-3.2 1.28 22.79 22.79 0 0 1-6.81 3.15 7.78 7.78 0 0 1-7.05-1.62c-1.5-1.47-2.06-3.61-2.79-5.59-1.18-3.2-3.33-6.49-6.68-7.13-1.44-.27-2.93 0-4.37-.24-9.75-1.57-4.02-16.36-6.99-22.35Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M542.92 212.45a45.71 45.71 0 0 0 5.44-12.5 15.73 15.73 0 0 1 2.5-5.14.87.87 0 0 1 1.57.6l-.4 4c2-2.32 4.37-6.57 7.72-10.1a.49.49 0 0 1 .8.52l-2.7 6.79a.27.27 0 0 0 .46.26l4-5.39c2.17-1.56 1.92.73 1.72 1.27l-2.61 5a.33.33 0 0 0 .52.38 36 36 0 0 1 3.63-3.12.84.84 0 0 1 1.2 1.11l-4 5.59c-.48.67-.89 1.06-.07 1l2.88-1.06c.86-.34.45 1.63-.3 2.16-4.19 3-5.89 5.34-8.79 7.83s-21.51 33.18-30 44.06c-3.09 3.95-9 6.58-11.39.22-1.79-4.82 3.7-9.33 6.34-12.82q11.35-14.86 21.48-30.66Z",
    transform: "translate(-100.66 -3.59)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m312.57 379.05-194.78-1.23a27.86 27.86 0 0 0-28 27.69l-.18 28.7a27.87 27.87 0 0 0 27.69 28.05l184.67 1.15a47.28 47.28 0 0 1 32.65 13.39l5.17 5 .29-46 .07-11 .11-17.72a27.86 27.86 0 0 0-27.69-28.03Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 69.38,
    height: 5.96,
    x: 275.3,
    y: 50.77,
    fill: "url(#h)",
    rx: 2.98
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M277.82 155.13c-5.28 2.28-6.21 1.92-11.86 2.91s-10.07.27-15.45-1.74c-3.69 11.26-7.61 23.56-8.61 35.36a78.7 78.7 0 0 1-1.71 10.55h-34c-.1-.76-.19-1.54-.27-2.35a174.48 174.48 0 0 1 .37-32.63 19.65 19.65 0 0 0 .17-2 6.85 6.85 0 0 0-.12-1.63 10.94 10.94 0 0 0-1.42-3.25c-1.35-2.37-4.61-6-6.42-8.63-.24-.36-.46-.7-.64-1 1.09-5 5.9-7.45 8.14-12a28.21 28.21 0 0 1 6.93-9.11 20.52 20.52 0 0 1 3-2.12c3.84-2.23 8.27-3.12 12.69-3.79.69-.11 1.37-.21 2.06-.3a18.12 18.12 0 0 0 9.71 3.46 12.84 12.84 0 0 1 3.28.35 9.57 9.57 0 0 1 2.52 1.44l1.34 1c2.46 1.75 4.92 3.52 7.38 5.28a37 37 0 0 0 5.43 3.42c6.17 2.92 8.72 2.65 15.5 1.79.79 4.27 1.59 10.58 1.98 14.99Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M329.23 127c-1.77 1.63 3.38 7.26 5.25 8.78s4.71 1.51 7.08.81c1.58-.46 3.26-1.35 3.69-2.95a7.89 7.89 0 0 0-.31-3.39c-.43-2.35 0-4.82-.64-7.14a11.35 11.35 0 0 0-4.15-5.83c-1.85-1.45-6.84-5.3-7.87-1.45-1.12 4.1 1.09 7.33-3.05 11.17Z",
    transform: "translate(-100.66 -3.59)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M328.83 205.8h-21a24.9 24.9 0 0 0-1.29-2.35 2.38 2.38 0 0 0-.35-.43 7.36 7.36 0 0 1-1.85-3.48 44.2 44.2 0 0 1 1.25-28.3 7 7 0 0 1 1.49-2.44c1.08-1.15 2.3-1.71 3.45-3.83 2.27-4.17 6.6-11.28 8.74-15.51.85 8.21-2.34 15.82-2 24.06.17 4.8.35 9.68 2 14.2a27.57 27.57 0 0 0 6.34 9.93c1.09 1.19 2.67 5.12 3.22 8.15Z",
    transform: "translate(-100.66 -3.59)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M376.46 143.66s1.77 12.91 1.7 12.17 25.25-7.64 32.48-31.61a9.15 9.15 0 0 1 2-2.09c9-6.72 10.4-9.55 7.71-7.9a7.11 7.11 0 0 1-4.76 1.21 23 23 0 0 0 2.75-2.74c1.06-1.29 3.38-2.62 3.95-4.18a1.1 1.1 0 0 0 .1-.56.8.8 0 0 0-.85-.57 2.22 2.22 0 0 0-1 .4 36.54 36.54 0 0 0-3.88 2.78c-.77.63-2.89 1.48-2.16 0 1.14-2.35 3.67-3.91 4.34-6.43a1 1 0 0 0-.06-.87c-.26-.32-.78-.22-1.16-.05-1.37.62-5.5 6.29-6.51 6.16s1.09-6.06 1.17-7.2c0-.31 0-.68-.27-.83s-.6 0-.84.23c-2.64 2.18-3 6.05-4.7 9a2.17 2.17 0 0 1-1.15 1.12c-1.09.32-2-.92-3.11-1.17a.91.91 0 0 0-.61 0c-.61.27-.52 1.22-.15 1.78 4.99 7.69-7.74 26.02-24.99 31.35Z",
    transform: "translate(-100.66 -3.59)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M302 156.72s-5.25 42.26-1.23 49.08h8.73a132.06 132.06 0 0 1 1-40.83s-.77-6.65-8.5-8.25Z",
    transform: "translate(-100.66 -3.59)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 102.94,
    height: 11.25,
    x: 76.94,
    y: 150.68,
    fill: "#68e1fd",
    opacity: 0.32,
    rx: 5.62
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 102.94,
    height: 11.25,
    x: 76.94,
    y: 173.71,
    fill: "#68e1fd",
    opacity: 0.32,
    rx: 5.62
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M519.04 275.59h-91.7a5.63 5.63 0 0 1-5.63-5.62 5.62 5.62 0 0 1 5.63-5.62h91.7a5.62 5.62 0 0 1 5.62 5.62 5.62 5.62 0 0 1-5.62 5.62ZM519.04 298.62h-91.7a5.63 5.63 0 0 1-5.63-5.62 5.62 5.62 0 0 1 5.63-5.59h91.7a5.62 5.62 0 0 1 5.62 5.62 5.62 5.62 0 0 1-5.62 5.59ZM260.76 407.5h-91.69a5.63 5.63 0 0 1-5.63-5.62 5.63 5.63 0 0 1 5.63-5.63h91.69a5.62 5.62 0 0 1 5.62 5.63 5.62 5.62 0 0 1-5.62 5.62Z",
    opacity: 0.32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 102.94,
    height: 11.25,
    x: 163.45,
    y: 421.95,
    fill: "#68e1fd",
    opacity: 0.32,
    rx: 5.62
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M421.34 256.26a12.08 12.08 0 0 1-3.29 4.92c-2.79 2.55-6.33 4.15-9.08 6.74-6.1 5.74-7.11 14.91-7.75 23.26l-2.19 28.83h-42a40.59 40.59 0 0 0-8.95 1q.81-11.6 1.4-23.2c.74-14.53.77-30.51-8.49-41.74a6.57 6.57 0 0 1-1.9-3.39c-.12-1.49.89-2.81 1.84-4 .06-.06.1-.12.16-.19l6.18-7.55c.75-.92 1.64-1.91 2.82-2a4 4 0 0 1 2.67 1.26 51 51 0 0 1 6.48 7.13c1.27 1.6 2.51 3.22 3.83 4.78 6.23 7.36 15.74 12.54 24.72 6.64a176.36 176.36 0 0 1 19.25-11.34 96.35 96.35 0 0 1 9.51-4c-.19 1.55.64 2.81 1.67 4a20.81 20.81 0 0 1 2.9 3.73 6.71 6.71 0 0 1 .22 5.12Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M448.76 251.74a16.49 16.49 0 0 0 1.8-11.32 49.15 49.15 0 0 0-3.66-11.08q-5.28-12.51-10.54-25a32.33 32.33 0 0 1-2.19-6.36c-.73-3.74-.14-7.6.45-11.36a2.75 2.75 0 0 0-2 .2 5.1 5.1 0 0 1-2.74 5 27.88 27.88 0 0 0-5-10.34q.39 4.19.58 8.4-3.3-3.39-6.62-6.76c-1.71 3 4.44 6.19 3 9.35l-7.26-5.23c-.53 3.56 5.23 5.24 5.54 8.84l-5.21-2.43c1.1 2.69 3.65 4.44 5.67 6.54 7.42 7.81 7.42 19.9 12.06 29.61 2.66 5.59 5.51 10.16 6.71 16.27.9 4.59 4.85 13 9.41 5.67Z",
    transform: "translate(-100.66 -3.59)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291.39,
    cy: 299.87,
    r: 7.87,
    fill: "#68e1fd",
    transform: "rotate(-22.64 232.15 549.538)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 315.57,
    cy: 299.87,
    r: 7.87,
    fill: "#68e1fd",
    transform: "rotate(-22.64 256.338 549.522)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.76,
    cy: 299.87,
    r: 7.87,
    fill: "#68e1fd",
    transform: "rotate(-22.64 280.522 549.532)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.23,
    cy: 429.82,
    r: 7.87,
    fill: "#68e1fd"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.41,
    cy: 429.82,
    r: 7.87,
    fill: "#68e1fd"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.59,
    cy: 429.82,
    r: 7.87,
    fill: "#68e1fd"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.17,
    cy: 161.92,
    r: 7.87,
    fill: "#68e1fd"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.36,
    cy: 161.92,
    r: 7.87,
    fill: "#68e1fd"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.54,
    cy: 161.92,
    r: 7.87,
    fill: "#68e1fd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m220.45 544.22 1.53 6.94c-9.94 7.21-22.67 8.93-34.63 11.7s-24.64 7.58-30.81 18.19c8.89 11.52 25.45 12.91 40 13.29q176 4.59 352.17 1.26c37.26-.71 74.73-1.7 111.3-8.87 2.62-.51 5.55-1.27 6.86-3.6 2.24-4-2-8.47-5.87-10.81a81.22 81.22 0 0 0-42.51-11.53c-5.62.07-13-.53-14.29-6-.44-1.95.16-4 .09-6-.16-4.95-4.45-9-9.16-10.5s-9.81-1-14.74-.55A1903.34 1903.34 0 0 1 300.82 544c-14.78-.76-29.58-1.68-44.26-3.56-13.78-1.74-23.75-4.44-36.11 3.78Z",
    opacity: 0.19,
    transform: "translate(-100.66 -3.59)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M359.49 115.38c-1.08 3.76-2.86 7.46-5.87 10a13.55 13.55 0 0 1-22.17-11.71c0-.31 0-.69-.22-.87a1.17 1.17 0 0 0-.72 0c-1.47.15-2.56-1.37-3-2.77a6.18 6.18 0 0 1-.29-3.32 3.18 3.18 0 0 1 2.13-2.39 2.19 2.19 0 0 1 2.66 1.43 13.59 13.59 0 0 1 2-5.86 22 22 0 0 1 4.48-6.2 14.17 14.17 0 0 1 14.47-2.28 16.12 16.12 0 0 1 9.11 9.72c.58 2-.27 3.73-.66 5.68-.65 2.82-1.1 5.73-1.92 8.57Z",
    transform: "translate(-100.66 -3.59)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M232.05 104.05a.7.7 0 0 1-.51.28c-.39 0-.49-.54-.52-.92a3.62 3.62 0 0 0-.95-2.52 1.73 1.73 0 0 0-2.45 0 18.62 18.62 0 0 1 2.64-12.65 2.75 2.75 0 0 0 .55-1.25c0-.59-.34-1.17-.23-1.75a2.15 2.15 0 0 1 .73-1.06 10.46 10.46 0 0 1 3.67-2.48 4.57 4.57 0 0 1 4.25.48 21.24 21.24 0 0 1 10.51-2.93 16.91 16.91 0 0 1 6.3 1.07 15.77 15.77 0 0 1 8.23 7.87 20.72 20.72 0 0 1 1.71 11.37A13.61 13.61 0 0 1 248.1 93a8.25 8.25 0 0 0 .49 4.66 8.72 8.72 0 0 1-4.72-6.25c-.75-.7-1.89.19-2.51 1-1.6 2.11-3.08 4.59-5 6.4a15.75 15.75 0 0 0-2.39 2.15c-.75.98-1.07 2.19-1.92 3.09Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M487.05 262.74c-.35 2.79-2.95 5.19-5.78 5.87a6.09 6.09 0 0 1-2.2.18c-4-.41-5.82-5.35-5.74-9.38s1-8.14-.84-11.57c-.05-.11-.11-.22-.17-.33-1-1.77-2.75-3.09-3.64-4.94a11.36 11.36 0 0 1-.52-6.57c1.19-8.36 7.74-30.45 20.36-22.18 3.27 2.14 5.22 5.84 6.34 9.58 3.96 13.18-4.5 12.96-7.81 39.34Z",
    transform: "translate(-100.66 -3.59)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M382.86 212.93c1.69 1 2.53 3 2.91 5 1.09 5.55-.68 11.21-1.67 16.78s-1 12 2.91 16.1l.09.1a8 8 0 0 0 13.08-2.5c.19-.43.41-.85.64-1.26 1.52-2.69 3.64-5 5.15-7.7a24 24 0 0 0 2.52-7.27 19.32 19.32 0 0 0 .05-7.87c-1-4.36-4-8-7.14-11.11-3-3-6.33-5.73-10.3-7.11s-8.71-1.16-12 1.43c-1 .8-3.75 4.05-2.32 5.4 1.17 1.07 4.31-1.07 6.08.01Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m202.38 153.13-4.56-2.45 3.29 4.51.24-2.06h1.03z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M351.17 159.89a4.57 4.57 0 0 1 4.78-4c4.48-.13 21.86-2.42 21.86-2.42l.67 5.28s-15.37 6.5-27.31 1.14Z",
    transform: "translate(-100.66 -3.59)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M376.46 143.66V146s-15.19 4.09-31.22-12.39l-.95-2.83a9.57 9.57 0 0 1 2.52 1.44l1.34 1c2.46 1.75 4.92 3.52 7.38 5.28a37 37 0 0 0 5.43 3.42c6.17 2.92 8.72 2.65 15.5 1.79ZM330.06 130.77S314.27 130 306.77 148c-1.61 3.84-5.57 7.76-5.57 7.76l-2.08-.44c-.24-.36-.46-.7-.64-1 1.09-5 5.9-7.45 8.14-12a28.21 28.21 0 0 1 6.93-9.11 20.52 20.52 0 0 1 3-2.12c3.84-2.23 8.27-3.12 12.69-3.79Z",
    opacity: 0.18,
    transform: "translate(-100.66 -3.59)",
    style: {
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M522 259.85a12.08 12.08 0 0 1-3.29 4.92c-2.79 2.55-6.33 4.15-9.08 6.74-6.1 5.74-7.11 14.91-7.75 23.26l-2.19 28.83h-31.77s17.29-35.12 22-44.42 19.11-15.42 19.11-15.42c11.22-8.71 12.97-3.91 12.97-3.91Z",
    transform: "translate(-100.66 -3.59)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M481.77 268.12a2.58 2.58 0 0 1-.5.49 6.09 6.09 0 0 1-2.2.18c-4-.41-5.82-5.35-5.74-9.38s1.57-7.92-1.77-13c1.75 1.27 4.07 2.06 9.15 2.39 3.67.2 1.47 18.8 1.06 19.32Z",
    transform: "translate(-100.66 -3.59)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c3c5468653cb63ac751692b5220d74df.svg";
export { ForwardRef as ReactComponent };